import { NavigationNodeId } from '@pwc/pwc-deals-web-common';
import { useTranslation } from 'react-i18next';
import { getNavigationTitle } from '../helpers/getCustomNavigationTitles';

export const useKfaTitle = () => {
  const { t } = useTranslation();
  const kfaTitle = getNavigationTitle(NavigationNodeId.KEY_FOCUS_AREAS);
  if (kfaTitle === NavigationNodeId.KEY_FOCUS_AREAS) {
    return t('keyFocusArea');
  }

  return kfaTitle;
};
